import * as types from './mutation-types'
import { API_STATES } from '@/helpers'
import { findIndex } from "lodash"

const mutations = {
  [types.GET_SCHEDULED_TASK_DATA_BEGIN](state) {
    state.scheduledTasksGetState = API_STATES.REQUEST_PENDING
  },
  [types.GET_SCHEDULED_TASK_DATA_SUCCESS](state, tasks) {
    state.scheduledTasksGetError = null
    state.scheduledTasks = tasks
    state.scheduledTasksGetState = API_STATES.REQUEST_SUCCESS
  },
  [types.GET_SCHEDULED_TASK_DATA_ERROR](state, err) {
    state.scheduledTasksGetState = API_STATES.REQUEST_ERROR
    state.scheduledTasksGetError = err
  },

  [types.TASK_ASSIGNMENT_BEGIN](state, id) {
    state.taskAssignmentUpdating.push(id)
    state.taskAssignmentUpdateState = API_STATES.REQUEST_PENDING
  },
  [types.TASK_ASSIGNMENT_SUCCESS](state, { updatedData, index }) {
    const completedVal = updatedData.completed===1 ?  false : true
    state.scheduledTasks.forEach((s)=>{
      if(s.workSchedule.id===updatedData.wsId && s.id===updatedData.taskId){
        s.isCompleted = completedVal
      }
    }) 

    const index1 = findIndex(state.taskAssignmentUpdating, index);
    state.taskAssignmentUpdating.splice(index1, 1);
    state.taskAssignmentUpdateError = null
    state.taskAssignmentUpdateState = API_STATES.REQUEST_SUCCESS
  },
  [types.TASK_ASSIGNMENT_ERROR](state, { e, id }) {
    const index = findIndex(state.taskAssignmentUpdating, id);
    state.taskAssignmentUpdating.splice(index, 1);
    state.taskAssignmentUpdateState = API_STATES.REQUEST_ERROR
    state.taskAssignmentUpdateError = e
  }
}

export default mutations